<div data-cy="connection-status-modal__page">
    <div mat-dialog-title>
        <h4 class="mb-10 inline-block title">
            <!-- {{ "new" | transloco | capitaliz }} -->
            {{ 'shared_projects.connection_requests' | transloco | capitaliz }}
        </h4>
        <button data-cy="connection-status-modal__btn" type="button" class="close modal-close-button" (click)="dialogRef.close()">
            <span aria-hidden="true"><i class="d-text-middle uil uil-multiply unicon-icon"></i></span>
            <span class="sr-only">Close</span>
        </button>
    </div>

    <!-- modal body -->
    <mat-dialog-content data-cy="connection-status-modal__dialog-content" class="p-none">
        <mat-tab-group [selectedIndex]="selectedTabIndex" (selectedTabChange)="onTabChange($event)">
            <mat-tab label="{{ 'shared_projects.received' | transloco | capitaliz }}">
                <div class="col-xs-12 px-20">
                    <mat-divider></mat-divider>
                    <mat-progress-bar *ngIf="isProcessing" mode="indeterminate"></mat-progress-bar>
                    <div *ngIf="!isProcessing" #tableContainer>
                        <table data-cy="connection-status-modal__table" mat-table [dataSource]="renderedData">
                            <!-- Position Column -->
                            <ng-container matColumnDef="Project name">
                                <th mat-header-cell *matHeaderCellDef> {{ 'shared_projects.project_name' | transloco | capitaliz }} </th>
                                <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                            </ng-container>

                            <!-- Name Column -->
                            <ng-container matColumnDef="Collaboration">
                                <th mat-header-cell *matHeaderCellDef> {{ 'shared_projects.collaboration' | transloco | capitaliz }} </th>
                                <td mat-cell *matCellDef="let element"> {{ (element.level=='chat'?'chat_sidebar.chat':'chat_sidebar.read') | transloco | capitaliz}} </td>
                            </ng-container>

                            <!-- Weight Column -->
                            <ng-container matColumnDef="items to share">
                                <th mat-header-cell *matHeaderCellDef> {{ 'shared_projects.items_to_share' | transloco | capitaliz }} </th>
                                <td mat-cell *matCellDef="let element"> {{ element.item | transloco }} </td>
                            </ng-container>

                            <!-- Symbol Column -->
                            <ng-container matColumnDef="Action">
                                <th mat-header-cell *matHeaderCellDef class="text-end"> {{ 'shared_projects.action' | transloco | capitaliz }} </th>
                                <td mat-cell *matCellDef="let element" class="text-end">
                                    <!-- Requested -->
                                    <ng-container *ngIf="element.status === 'requested'">
                                        <!-- <span *ngIf="element.metadata?.shared_status === 'requested'"
                                              class="changes-badge d-inline-flex align-items-center">
                                            <i class="uil uil-exclamation-triangle mr-2"></i>
                                            <span>{{ getChangesCount(element) }} {{ 'shared_projects.changes' | transloco }}</span>
                                        </span> -->
                                        <span class="d-inline-flex align-items-center">
                                            <span data-cy="connection-status-modal__change-status" class="title mr-8 d-cursor-hand"
                                                  (click)="changeStatus(element,'accepted')">{{ 'shared_projects.accept' | transloco | capitaliz }}</span>
                                        <span data-cy="connection-status-modal__change-status-2" class="title d-cursor-hand" (click)="changeStatus(element,'cancelled')">{{ 'cancel' | transloco | capitaliz }}</span>
                                        </span>
                                    </ng-container>

                                    <!-- Accepted -->
                                    <ng-container *ngIf="element.status === 'accepted'">
                                        <span *ngIf="element.metadata?.shared_status === 'requested'"
                                              class="changes-badge d-inline-flex align-items-center">
                                            <i class="uil uil-exclamation-triangle mr-2"></i>
                                            <span>{{ getChangesCount(element) }} {{ 'shared_projects.changes' | transloco }}</span>
                                        </span>
                                        <span *ngIf="element.metadata?.shared_status !== 'requested'">
                                            <!-- <span class="title mr-8 d-cursor-hand" (click)="editConnection(element)">{{ 'shared_projects.edit' | transloco | capitaliz }}</span> -->
                                            <span data-cy="connection-status-modal__change-status-3" class="title d-cursor-hand" (click)="changeStatus(element,'cancelled')">{{ 'cancel' | transloco | capitaliz }}</span>
                                        </span>
                                    </ng-container>
                                </td>
                            </ng-container>

                            <!-- Group Header Row -->
                            <ng-container matColumnDef="groupHeader">
                                <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length" class="project-type-label">
                                    {{ ('shared_projects.' + row.label) | transloco | capitaliz }}
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: groupHeaderColumns; when: isGroupHeaderRow"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns; when: isProjectRow" [attr.data-row-id]="row.id"></tr>

                            <!-- Empty row message -->
                            <tr class="mat-row" *matNoDataRow>
                                <td [attr.colspan]="4" class="no-data-cell">
                                    {{ 'shared_projects.no_connections_yet' | transloco | capitaliz }} <a data-cy="connection-status-modal__dotted-link" (click)="navigateToKaart()" class="dotted-link">{{ 'shared_projects.go_to_map' | transloco | capitaliz }}</a>  {{ 'shared_projects.and_make_one' | transloco }}.
                                </td>
                            </tr>
                        </table>

                        <!-- Detail boxes rendered below the table, positioned with CSS -->
                        <ng-container *ngFor="let element of dataSource; trackBy: trackByFn">
                            <div class="changes-detail-wrapper"
                                 *ngIf="isRowExpanded(element) && hasMetadataInfo(element) && (element.status === 'accepted' && element.metadata?.shared_status === 'requested')"
                                 [attr.data-detail-for]="element.id">
                                <div class="changes-detail-box">
                                    <div class="changes-header">
                                        <div class="changes-title">{{ 'shared_projects.changes_since_last_update' | transloco | capitaliz }}</div>
                                        <div class="changes-actions">
                                            <span data-cy="connection-status-modal__change-status-4" class="title mr-8 d-cursor-hand"
                                                  (click)="changeStatus(element,'accepted', true)">{{ 'shared_projects.accept' | transloco | capitaliz }}</span>
                                            <span data-cy="connection-status-modal__change-status-5" class="title d-cursor-hand" (click)="changeStatus(element,'cancelled', true)">{{ 'cancel' | transloco | capitaliz }}</span>
                                        </div>
                                    </div>
                                    <div class="changes-content">
                                        <div class="changes-row">
                                            <div class="changes-section" *ngIf="hasLevelUpgrade(element)">
                                                <div class="change-content">
                                                    <div class="change-label">{{ 'shared_projects.collaboration' | transloco | capitaliz }}</div>
                                                    <div class="change-value" *ngIf="getCollaborationLevelChange(element)">
                                                        <span>{{ getCollaborationLevelChange(element)!.old | transloco | capitaliz }}</span>
                                                        <span> → </span>
                                                        <span>{{ getCollaborationLevelChange(element)!.new | transloco | capitaliz }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="changes-section" *ngIf="element.metadata?.modules_added && element.metadata.modules_added.length > 0">
                                                <div class="change-content">
                                                    <div class="change-label">{{ 'shared_projects.items_to_share' | transloco | capitaliz }}</div>
                                                    <div class="change-items-list">
                                                        <div *ngFor="let module of element.metadata.modules_added" class="change-item">
                                                            <i class="uil uil-plus-circle change-add-icon"></i>
                                                            <span>{{ 'reusable.project_setting.' + module.module_name | transloco }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="changes-section users-section" *ngIf="element.metadata?.users_added && element.metadata.users_added.length > 0">
                                            <div class="change-content">
                                                <div class="change-label">{{ 'shared_projects.users' | transloco | capitaliz }}</div>
                                                <div class="change-items-list">
                                                    <div *ngFor="let user of element.metadata.users_added" class="change-item">
                                                        <i class="uil uil-plus-circle change-add-icon"></i>
                                                        <span>{{ user.name || user.email || ('shared_projects.user' | transloco) + ' ' + user.id }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="changes-footer">
                                        {{ 'shared_projects.acceptance_message' | transloco }}
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </mat-tab>
            <mat-tab label="{{ 'shared_projects.sent' | transloco | capitaliz }}">
                    <div class="col-xs-12 px-20">
                        <mat-divider></mat-divider>
                        <mat-progress-bar *ngIf="isProcessing" mode="indeterminate"></mat-progress-bar>
                        <div *ngIf="!isProcessing">
                            <table data-cy="connection-status-modal__table-2" mat-table [dataSource]="renderedData">
                                <!-- Name Column -->
                                <ng-container matColumnDef="Project name">
                                    <th mat-header-cell *matHeaderCellDef> {{ 'shared_projects.project_name' | transloco | capitaliz }} </th>
                                    <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                                </ng-container>

                                <!-- Level Column -->
                                <ng-container matColumnDef="Collaboration">
                                    <th mat-header-cell *matHeaderCellDef> {{ 'shared_projects.collaboration' | transloco | capitaliz }} </th>
                                    <td mat-cell *matCellDef="let element"> {{ (element.level=='chat'?'chat_sidebar.chat':'chat_sidebar.read') | transloco  | capitaliz}} </td>
                                </ng-container>

                                <!-- Item Column -->
                                <ng-container matColumnDef="items to share">
                                    <th mat-header-cell *matHeaderCellDef> {{ 'shared_projects.items_to_share' | transloco | capitaliz }} </th>
                                    <td mat-cell *matCellDef="let element"> {{ element.item | transloco }} </td>
                                </ng-container>

                                <!-- Status Column -->
                                <ng-container matColumnDef="Action">
                                    <th mat-header-cell *matHeaderCellDef class="text-end"> {{ 'shared_projects.action' | transloco | capitaliz }} </th>
                                    <td mat-cell *matCellDef="let element" class="text-end">

                                        <!-- Accepted/Requested -->
                                        <ng-container class="title mr-8" *ngIf="element.status === 'accepted' || element.status === 'requested'">
                                            <span data-cy="connection-status-modal__edit-connection" class="title mr-8 d-cursor-hand" *ngIf="element.status !== 'requested'" (click)="editConnection(element)">{{ 'shared_projects.edit' | transloco | capitaliz }}</span>
                                            <span data-cy="connection-status-modal__change-status-6" class="title d-cursor-hand" (click)="changeStatus(element,'cancelled')">{{ 'cancel' | transloco | capitaliz }}</span>
                                        </ng-container>

                                    </td>
                                </ng-container>

                                <!-- Group Header Row -->
                                <ng-container matColumnDef="groupHeader">
                                    <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length" class="project-type-label">
                                        {{ ('shared_projects.' + row.label) | transloco | capitaliz }}
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: groupHeaderColumns; when: isGroupHeaderRow"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns; when: isProjectRow"></tr>

                                <!-- Empty row message -->
                                <tr class="mat-row" *matNoDataRow>
                                    <td [attr.colspan]="4" class="no-data-cell">
                                        {{ 'shared_projects.no_connections_yet' | transloco | capitaliz }} <a data-cy="connection-status-modal__dotted-link-2" (click)="navigateToKaart()" class="dotted-link">{{ 'shared_projects.go_to_map' | transloco | capitaliz }}</a>  {{ 'shared_projects.and_make_one' | transloco }}
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
            </mat-tab>
            <mat-tab label="{{ 'cancelled' | transloco | capitaliz }}">
                <div class="col-xs-12 px-20">
                    <mat-divider></mat-divider>
                    <mat-progress-bar *ngIf="isProcessing" mode="indeterminate"></mat-progress-bar>
                    <div *ngIf="!isProcessing">
                        <table data-cy="connection-status-modal__table-3" mat-table [dataSource]="renderedData">
                            <!-- Name Column -->
                            <ng-container matColumnDef="Project name">
                                <th mat-header-cell *matHeaderCellDef> {{ 'shared_projects.project_name' | transloco | capitaliz }} </th>
                                <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                            </ng-container>

                            <!-- Level Column -->
                            <ng-container matColumnDef="Collaboration">
                                <th mat-header-cell *matHeaderCellDef> {{ 'shared_projects.collaboration' | transloco | capitaliz }} </th>
                                <td mat-cell *matCellDef="let element"> {{ (element.level=='chat'?'chat_sidebar.chat':'chat_sidebar.read') | transloco  | capitaliz}} </td>
                            </ng-container>

                            <!-- Item Column -->
                            <ng-container matColumnDef="items to share">
                                <th mat-header-cell *matHeaderCellDef> {{ 'shared_projects.items_to_share' | transloco | capitaliz }} </th>
                                <td mat-cell *matCellDef="let element"> {{ element.item | transloco }} </td>
                            </ng-container>

                            <!-- Status Column -->
                            <ng-container matColumnDef="Action">
                                <th mat-header-cell *matHeaderCellDef class="text-end"> {{ 'shared_projects.action' | transloco | capitaliz }} </th>
                                <td mat-cell *matCellDef="let element" class="text-end">

                                    <!-- Rejected -->
                                    <ng-container class="title mr-8" *ngIf="element.status === 'rejected' || element.status === 'cancelled'">
                                        <span class="title mr-8" *ngIf="element.is_receiver">{{ 'cancelled' | transloco| capitaliz}}</span>
                                        <span data-cy="connection-status-modal__resend-connection-request" class="title d-cursor-hand" *ngIf="element.is_receiver==false" (click)="resendConnectionRequest(element,'requested')">{{ 'shared_projects.resend' | transloco | capitaliz }}</span>
                                    </ng-container>

                                </td>
                            </ng-container>

                            <!-- Group Header Row -->
                            <ng-container matColumnDef="groupHeader">
                                <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length" class="project-type-label">
                                    {{ ('shared_projects.' + row.label) | transloco | capitaliz }}
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: groupHeaderColumns; when: isGroupHeaderRow"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns; when: isProjectRow"></tr>

                            <!-- Empty row message -->
                            <tr class="mat-row" *matNoDataRow>
                                <td [attr.colspan]="4" class="no-data-cell">
                                    {{ 'shared_projects.no_connections_yet' | transloco | capitaliz }} <a data-cy="connection-status-modal__dotted-link-3" (click)="navigateToKaart()" class="dotted-link">{{ 'shared_projects.go_to_map' | transloco | capitaliz }}</a>  {{ 'shared_projects.and_make_one' | transloco }}
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>

    </mat-dialog-content>
</div>
